export const COLORS = {
  bg: '#111827',
  bgLight: '#1F2937',
  bgCard: '#1a2236',
  border: '#374151',
  primary: '#3B82F6',
  primaryHover: '#2563EB',
  accent: '#1e88ff',
  green: '#2ecc71',
  greenDark: '#16a34a',
  yellow: '#f4b740',
  red: '#ef4444',
  redDark: '#b91c1c',
  text: '#e6eef7',
  textMuted: '#6B7280',
  white: '#ffffff',
};

export const BREAKPOINTS = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1280px',
};

export const SKELETON_STYLE = {
  background: 'linear-gradient(90deg, #374151 25%, #4B5563 50%, #374151 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
  borderRadius: '8px',
};
